import { Route, Routes } from 'react-router-dom';
import { ToursMainPage } from '../pages/tours/ToursMainPage';
import { TourDetailPage } from '../pages/tours/TourDetailPage';

export const ToursRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<ToursMainPage />} />
            <Route path="/detail" element={<TourDetailPage />} />
        </Routes>
    );
};
